import { render, staticRenderFns } from "./EntityInstanceUI.vue?vue&type=template&id=85f2244c&scoped=true&"
import script from "./EntityInstanceUI.vue?vue&type=script&lang=js&"
export * from "./EntityInstanceUI.vue?vue&type=script&lang=js&"
import style0 from "./EntityInstanceUI.vue?vue&type=style&index=0&id=85f2244c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f2244c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})
